import { useEffect, useState } from 'react';
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { AnimatedDashboard } from '../../components/animation/AnimatedDashboard';
import Spinner from '../../components/common/Spinner';
import {
  MY_HUBS,
  MY_HUBS_AKASHA,
  MY_HUBS_BIG_WHALE,
  MY_HUBS_DEX_NET,
  MY_HUBS_GUARDIAN,
  MY_HUBS_KRIPTO_TAP,
  MY_HUBS_TRAVEL
} from '../../routes/routes';
import { Flexed, TabSelectButton, Tabs } from '../../styles/GlobalComponents';
import { Conversion } from './Conversion/Conversion';
import { DexNetSummary } from './DexNetSummary';
import { GuardianSummary } from './GuardianSummary';
import { KriptoTapSummary } from './KriptoTapSummary';
import { MembershipStatus } from './MembershipStatus';
import { Overlay } from './Overlay';
import { getMyHubsAkasha, getMyHubsSummary } from './Portfolio.actions';
import { WalletSummary } from './WalletSummary';
import { WithdrawStepsEnum } from './WithdrawHubs/types';

export const Portfolio = () => {
  const dispatch = useAppDispatch();

  const [withdrawStep, setWithdrawStep] = useState<WithdrawStepsEnum>(
    WithdrawStepsEnum.INIT
  );
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const { loading, loadingHubs, akashaPackages, walletSummary } =
    useAppSelector((state) => state.portfolio);

  const { canBuyTravelPackages, canBuyAkashaPackages } = useAppSelector(
    (state) => state.auth.userInfo
  );

  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (walletSummary !== null) return;
    dispatch(getMyHubsSummary());
    dispatch(getMyHubsAkasha());
  }, [dispatch]);

  const pathname = location.pathname;

  if (loading) return <Spinner fullScreen={true} />;

  const showTabs = () => {
    if (
      canBuyAkashaPackages ||
      (!canBuyAkashaPackages && akashaPackages?.userPackages?.length !== 0)
    ) {
      return MY_HUBS_AKASHA;
    }
    if (canBuyTravelPackages) {
      return MY_HUBS_TRAVEL;
    } else {
      return MY_HUBS_BIG_WHALE;
    }
  };

  const showAkashaTab = () => {
    if (
      canBuyAkashaPackages ||
      (!canBuyAkashaPackages && akashaPackages?.userPackages?.length !== 0)
    )
      return (
        <TabSelectButton
          onClick={() => history.push(MY_HUBS_AKASHA)}
          selected={pathname === MY_HUBS_AKASHA}>
          <div>Super Node</div>
        </TabSelectButton>
      );
  };
  return (
    <AnimatedDashboard zoom dark>
      <WalletSummary />
      {/* <FlipMeBanner isOpen={isOpen} setIsOpen={setIsOpen} /> */}
      <MembershipStatus />

      <Flexed mb='20'>
        <Tabs>
          {/* {showAkashaTab()} */}
          {/* {canBuyTravelPackages && (
            <TabSelectButton
              onClick={() => history.push(MY_HUBS_TRAVEL)}
              selected={pathname === MY_HUBS_TRAVEL}>
              <div>Travel</div>
            </TabSelectButton>
          )} */}
          {/* <TabSelectButton
            onClick={() => history.push(MY_HUBS_BIG_WHALE)}
            selected={pathname === MY_HUBS_BIG_WHALE}>
            <div>BigWhale</div>
          </TabSelectButton>

          <TabSelectButton
            onClick={() => history.push(MY_HUBS_TRADING)}
            selected={pathname === MY_HUBS_TRADING}>
            <div>Trading</div>
          </TabSelectButton>
          <TabSelectButton
            onClick={() => history.push(MY_HUBS_PAYMENT)}
            selected={pathname === MY_HUBS_PAYMENT}>
            <div>Payment</div>
          </TabSelectButton>

          <TabSelectButton
            onClick={() => history.push(MY_HUBS_GAMING)}
            selected={pathname === MY_HUBS_GAMING}>
            <div>Gaming</div>
          </TabSelectButton> */}
          <TabSelectButton
            onClick={() => history.push(MY_HUBS_GUARDIAN)}
            selected={pathname === MY_HUBS_GUARDIAN}>
            <div>Guardian</div>
          </TabSelectButton>

          <TabSelectButton
            onClick={() => history.push(MY_HUBS_KRIPTO_TAP)}
            selected={pathname === MY_HUBS_KRIPTO_TAP}>
            <div>KriptoTap</div>
          </TabSelectButton>

          <TabSelectButton
            onClick={() => history.push(MY_HUBS_DEX_NET)}
            selected={pathname === MY_HUBS_DEX_NET}>
            <div>DexNet</div>
          </TabSelectButton>
        </Tabs>
      </Flexed>

      {loadingHubs && <Spinner fullScreen={true} transparent />}

      <Switch location={location} key={location.pathname}>
        <Redirect exact from={MY_HUBS} to={showTabs()} />
        {/* <Route path={MY_HUBS_AKASHA}>
          <AkashaSummary />
        </Route>
        <Route path={MY_HUBS_TRAVEL}>
          <TravelSummary />
        </Route>
        <Route path={MY_HUBS_BIG_WHALE}>
          <BigWhaleSummary />
        </Route>
        <Route path={MY_HUBS_TRADING}>
          <TradingHubSummary />
        </Route>
        <Route path={MY_HUBS_PAYMENT}>
          <PaymentHubSummary
            setWithdrawStep={setWithdrawStep}
            withdrawStep={withdrawStep}
          />
        </Route> */}

        {/* <Route path={MY_HUBS_FLIPME_CARDS}>
          <PaymentHubSummary
            setWithdrawStep={setWithdrawStep}
            withdrawStep={withdrawStep}
          />
        </Route>
        <Route path={MY_HUBS_GAMING}>
          <GamingHubSummary
            setWithdrawStep={setWithdrawStep}
            withdrawStep={withdrawStep}
          />
        </Route> */}
        <Route path={MY_HUBS_GUARDIAN}>
          <GuardianSummary />
        </Route>
        <Route path={MY_HUBS_KRIPTO_TAP}>
          <KriptoTapSummary />
        </Route>
        <Route path={MY_HUBS_DEX_NET}>
          <DexNetSummary />
        </Route>
      </Switch>

      <Conversion pathname={pathname} />

      <Overlay />
    </AnimatedDashboard>
  );
};
